module.exports = __webpack_public_path__ + "media/images/new_home/tiktok-icon-0480e4c04410422c63970f23a435fed9.png";